var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCounterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_mirroring-screen",
    "data-name": "vuesax/linear/mirroring-screen",
    transform: "translate(-236 -380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mirroring-screen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,6V5A4.724,4.724,0,0,1,5,0H15a4.724,4.724,0,0,1,5,5v8a4.724,4.724,0,0,1-5,5H14",
    transform: "translate(238 383)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0A9.75,9.75,0,0,1,8.61,8.61",
    transform: "translate(239.69 391.71)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0A7.155,7.155,0,0,1,6.32,6.32",
    transform: "translate(238.62 395.07)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0A3.582,3.582,0,0,1,3.16,3.16",
    transform: "translate(237.98 398.86)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(236 380)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterIcon);
export default __webpack_public_path__ + "static/media/counterIcon.07ae77f6cbe2d18473128760a4f201d3.svg";
export { ForwardRef as ReactComponent };